import { Panel, PanelTheme, PanelBorderRadius } from '@apply/components';

export const ReviewDisclaimer: React.FC = () => {
    return (
        <Panel
            theme={PanelTheme.Yellow}
            borderRadius={PanelBorderRadius.Medium}
        >
            <div className='reviewDisclaimerPanel'>
                Please review the properties above before submitting your application.
                <br />
                <br />
                To correct any information, please use the edit button above in the property's header.
            </div>
        </Panel>
    );
};
